// src/components/HeaderFirmasBadge.tsx
import { useEffect, useState, useRef } from 'react';
import { getPendingCount } from '../api/firmas';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeaderFirmasBadge({ refreshMs = 0 }: { refreshMs?: number }) {
  const { t } = useTranslation<'translation'>();
  const [n, setN] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const nav = useNavigate();
  const timer = useRef<number | undefined>(undefined);

  async function load() {
    try {
      setLoading(true);
      const count = await getPendingCount();
      setN(count);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    if (refreshMs && refreshMs > 0) {
      timer.current = window.setInterval(load, refreshMs) as unknown as number;
      return () => {
        if (timer.current) window.clearInterval(timer.current);
      };
    }
  }, [refreshMs]);

  const label = loading ? t('headerFirmasBadge.loading') : n > 99 ? '99+' : String(n);

  return (
    <button
      onClick={() => nav('/app/firmas/pendientes')}
      title={t('headerFirmasBadge.title') as string}
      style={{
        border: 'none',
        background: n > 0 ? '#fae45b' : '#777',
        color: '#545448',
        borderRadius: 10,
        padding: '6px 10px',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
      }}
    >
      {t('headerFirmasBadge.label')}
      <span
        style={{
          backgroundColor: Number(label) === 0 ? '#1e9e85' : '#ff4d4f',
          color: '#fff',
          padding: '2px 6px',
          borderRadius: 10,
          fontSize: 12,
          fontWeight: 700,
          minWidth: 10,
          minHeight: 10,
          textAlign: 'center',
        }}
      >
        {label}
      </span>
    </button>
  );
}
